import type { DataSource } from "@slfinrtl/ui-bff-routes"
import { waitForAppMeasurement } from "../waitForAppMeasurement"

export type AnalyticsPage =
	| "account"
	| "buildsheets"
	| "delivered_vehicles"
	| "delivered_vehicle_details"
	| "delivered_vehicle_details_buildsheet"
	| "delivered_vehicle_details_vehicle_history"
	| "extracosts_overview"
	| "extracosts_specification"
	| "extracosts_dealer_fee_add_rule"
	| "extracosts_dealer_fee_edit_rule"
	| "home"
	| "inquiry_context"
	| "inventory"
	| "inventory_vehicle_details"
	| "inventory_vehicle_details_buildsheet"
	| "inventory_vehicle_details_vehicle_history"
	| "inventory_integration_monitor"
	| "media_list"
	| "media_list_edit"
	| "media_edit"
	| "notification_center"
	| "online_reservations"
	| "showroom"
	| "syp_detail_page"
	| "syp_overview_page"
	| "trade_in_request_details"
	| "trade_in_requests"
	| "used_delivered_vehicle_details"
	| "used_delivered_vehicle_details_buildsheet"
	| "used_delivered_vehicle_details_vehicle_history"
	| "vehicle_history"
	| "vehicle_information_buildsheet"
	| "vehicle_information_monroney_label"
	| "vehicle_information_vehicle_history"
	| "vehicle_deliver"
	| "vehicle_remove"
	| "vehicle_reserve_create"
	| "vehicle_reserve_edit"
	| "vehicle_reserve_create_success"
	| "vehicle_reserve_edit_success"
	| "vehicle_reserve_cancel_success"
	| "vehicle_transfer"
	| "offer_details"
	| "offer_overview"
	| "offer_create"
	| "offer_edit"
	| "news_list"
	| "news_create"
	| "news_edit"

export const trackPageView = (pageId: AnalyticsPage, dataSource?: DataSource) => {
	waitForAppMeasurement((s) => {
		s.events = "event1"
		s.pageName = pageId
		s.prop1 = pageId
		s.eVar1 = pageId

		s.prop6 = window.location.href
		s.eVar6 = window.location.href

		if (dataSource) {
			s.eVar196 = dataSource
		}

		// https://experienceleague.adobe.com/en/docs/analytics/implementation/vars/functions/t-method#st-method-in-appmeasurement-and-the-analytics-extension-custom-code-editor
		s.t()

		s.eVar196 = undefined
	})
}
